import { useMemo } from "react";
import Text from "../../../../Component/Elements/Text/Text";
import { BrandInfoProps } from "./interface/BrandInfo.interface";
import CSS from "./static/css/BrandInfo.module.css";

const BrandInfo = (
    {
        title_line1,
        title_line2,
        title_line3,
        description,
        image,
        version,
    }:  BrandInfoProps,

) => {
    const brandInfoMainClassName = useMemo(() => {
        const RTN: string[] = [CSS.l_BrandInfo_main];

        if(version){
            RTN.push(CSS.version);
            RTN.push(CSS[version]);
        }

        return RTN.join(" ");
    }, [version]);

    const brandInfoTextContainerClassName = useMemo(() => {
        const RTN: string[] = [CSS.l_BrandInfo_textContainer];

        if(version){
            RTN.push(CSS.version);
            RTN.push(CSS[version]);
        }

        return RTN.join(" ");
    }, [version])

    const brandInfoDescriptionClassName = useMemo(() => {
        const RTN: string[] = [CSS.l_BrandInfo_description];

        if(version){
            RTN.push(CSS.version);
            RTN.push(CSS[version]);
        }

        return RTN.join(" ");
    }, [version]);

    const brandInfoTitleContainerClassName = useMemo(() => {
        const RTN: string[] = [CSS.l_BrandInfo_titleContainer];

        if(version){
            RTN.push(CSS.version);
            RTN.push(CSS[version]);
        }

        return RTN.join(" ");
    }, [version]);

    const brandInfoTitleClassName = useMemo(() => {
        const RTN: string[] = [CSS.l_BrandInfo_title];

        if(version){
            RTN.push(CSS.version);
            RTN.push(CSS[version]);
        }

        return RTN.join(" ");
    }, [version]);

    const brandInfoImageContainerClassName = useMemo(() => {
        const RTN: string[] = [CSS.l_BrandInfo_imageContainer];

        if(version){
            RTN.push(CSS.version);
            RTN.push(CSS[version]);
        }

        return RTN.join(" ");
    }, [version]);

    return(
        <div className={brandInfoMainClassName}>
            <div className={brandInfoTextContainerClassName}>
                <Text 
                    class_name_list={[brandInfoDescriptionClassName]}
                    color="primary"
                >
                    {description}
                </Text>
                <div className={brandInfoTitleContainerClassName}>
                    {
                        version === "v1"
                        ?   <>
                                <Text 
                                    class_name_list={[brandInfoTitleClassName]}
                                    color="dark"
                                    text_wrap="nowrap"
                                    bold={true}
                                >
                                    {`${title_line1} ${title_line2}`}
                                </Text>
                                <Text 
                                    class_name_list={[brandInfoTitleClassName]}
                                    color="dark"
                                    text_wrap="nowrap"
                                    bold={true}
                                >
                                    {title_line3}
                                </Text>
                            </>
                        :   <>
                                <Text 
                                    class_name_list={[brandInfoTitleClassName]}
                                    color="dark"
                                    text_wrap="nowrap"
                                    bold={true}
                                >
                                    {title_line1}
                                </Text>
                                <Text 
                                    class_name_list={[brandInfoTitleClassName]}
                                    color="dark"
                                    text_wrap="nowrap"
                                    bold={true}
                                >
                                    {`${title_line2} ${title_line3}`}
                                </Text>
                            </>
                    }
                </div>
            </div>
            <div className={brandInfoImageContainerClassName}>
                <img 
                    className={CSS.l_BrandInfo_image}
                    src={image}
                />
            </div>
        </div>
    )
}

export default BrandInfo;